import { toast } from "react-toastify";

/**
 * Handles a successful API response and dispatches a Redux action.
 * This is a helper function used by the request handlers.
 */
const handleSuccess = (
  dispatch,
  successActionType,
  successMessage,
  payload
) => {
  if (successMessage) {
    toast.success(successMessage);
  }
  dispatch({
    type: successActionType,
    payload,
  });
};

/**
 * Handles an API error and dispatches an error action.
 * This is a helper function used by the request handlers.
 */
const handleError = (dispatch, errorActionType, error) => {
  const errorMessage =
    error.response && error.response.data.message
      ? error.response.data.message
      : error.message;

  toast.error("Something Bad Happened");
  dispatch({
    type: errorActionType,
    payload: errorMessage,
  });
};

/**
 * Creates a generic handler for POST, PATCH, and DELETE operations.
 * It automatically handles dispatching request, success, and error actions.
 */
export const createRequestHandler = async (
  dispatch,
  apiCall,
  actionTypes,
  successMessage
) => {
  dispatch({
    type: actionTypes.request,
  });

  try {
    const response = await apiCall();
    handleSuccess(dispatch, actionTypes.success, successMessage, response.data);
  } catch (error) {
    handleError(dispatch, actionTypes.error, error);
  }
};

/**
 * Creates a generic handler for GET requests that have download progress.
 * It handles the entire request lifecycle and dispatches progress updates.
 */
export const createProgressiveRequestHandler = async (
  dispatch,
  apiCall,
  actionTypes,
  createProgressHandler
) => {
  dispatch({
    type: actionTypes.request, // Dispatch the general request action
  });
  dispatch({
    type: actionTypes.start, // Dispatch the download start action
  });

  try {
    const response = await apiCall();
    // Dispatch the finish action upon completion
    dispatch({
      type: actionTypes.finish,
    });

    handleSuccess(dispatch, actionTypes.success, null, response.data);
  } catch (error) {
    // Dispatch finish action on error to stop loader
    dispatch({
      type: actionTypes.finish,
    });
    handleError(dispatch, actionTypes.error, error);
  }
};
